<template>
    <router-view />
</template>

<script>
export default {
  name: 'Credit',
  beforeRouteEnter (to, from, next) {
    next()
  }
}
</script>

<style scoped>

</style>
